/**
 * Installation connect-services route — eagerly registers the file route; the
 * page component and its atom/RPC imports are deferred to `index.lazy.tsx` so
 * they load only with this route, never in the always-loaded `main` chunk
 * (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/installations/$installationId/")({});
